import { useEffect, useState } from "react";

const css = `
@keyframes nl-sweep {
  0% { background-position: 140% 0; }
  100% { background-position: -140% 0; }
}
.nl-n {
  -webkit-mask: url('/logo-icon.png') center / contain no-repeat;
  mask: url('/logo-icon.png') center / contain no-repeat;
}
.nl-n-shimmer {
  background-color: rgba(255,255,255,0.07);
  background-image: linear-gradient(105deg, rgba(255,255,255,0) 38%, rgba(255,255,255,0.38) 50%, rgba(255,255,255,0) 62%);
  background-size: 240% 100%;
  background-repeat: no-repeat;
  animation: nl-sweep 1.7s infinite linear;
}
.nl-n-ghost { background-color: rgba(255,255,255,0.07); }
.nl-skel {
  background-color: rgba(255,255,255,0.05);
  background-image: linear-gradient(100deg, rgba(255,255,255,0) 40%, rgba(255,255,255,0.14) 50%, rgba(255,255,255,0) 60%);
  background-size: 220% 100%;
  background-repeat: no-repeat;
  animation: nl-sweep 1.6s infinite linear;
  border-radius: 6px;
}
`;

export const useMinLoading = (isLoading: boolean, ms = 700, key?: string) => {
  const [elapsed, setElapsed] = useState(false);
  useEffect(() => {
    setElapsed(false);
    const t = setTimeout(() => setElapsed(true), ms);
    return () => clearTimeout(t);
  }, [ms, key]);
  return isLoading || !elapsed;
};

export const PageLoader = () => (
  <div className="min-h-[65vh] flex items-center justify-center" data-testid="page-loader">
    <style>{css}</style>
    <div className="nl-n nl-n-shimmer w-28 h-28" />
  </div>
);

export const ArticleSkeleton = () => (
  <div className="max-w-4xl mx-auto px-4 py-16 flex justify-center" data-testid="article-loader">
    <style>{css}</style>
    <div className="w-full max-w-xl">
      <div className="nl-n nl-n-ghost w-10 h-10 mx-auto mb-6" />
      <div className="nl-skel w-full aspect-[16/7] mb-4" />
      <div className="nl-skel h-5 w-11/12 mb-2.5" />
      <div className="nl-skel h-5 w-4/5 mb-5" />
      <div className="nl-skel h-3.5 w-2/5 mb-2" />
      <div className="nl-skel h-3.5 w-3/5" />
    </div>
  </div>
);
